module.exports = __webpack_public_path__ + "static/img/people3.36a9c9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/people3.jpg
// module id = tlTo
// module chunks = 1